import React from 'react';
import Templates from '../Pages/templates';
import Setting from '../Pages/setting';
import Account from '../Pages/account'; // Updated to reflect 'account.jsx'
import { createBrowserRouter } from 'react-router-dom';

export const Router = createBrowserRouter([
  {
    path: '/',
    element: <Templates />,
  },
 
  {
    path: '/Templates',
    element: <Templates />,
  },
 
  {
    path: '/Setting',
    element: <Setting />,
  },
  {
    path: '/account',
    element: <Account />,  // Using 'Account' from account.jsx
  },
]);

export default Router;